import {ButtonProps, withTheme} from '@rneui/themed';

import Button from '../ui-controls/Button';

export default withTheme<ButtonProps>(Button as any, 'LMGButton');

declare module '@rneui/themed' {
  export interface ComponentTheme {
    LMGButton: Partial<
      ButtonProps & {
        secondary?: boolean;
        variant?: 'text' | 'outlined' | 'contained';
      }
    >;
  }
}
